import { fromJS } from 'immutable';
const action = name => `/userMST/${name}`;

//login
export const LOGIN = action('LOGIN');
export const LOGIN_SUCCESS = action('LOGIN_SUCCESS');
export const LOGIN_ERROR = action('LOGIN_ERROR');

export const userLogin = data => ({ type: LOGIN, data });
export const userLoginSuccess = data => ({ type: LOGIN_SUCCESS, data });
export const userLoginError = data => ({ type: LOGIN_SUCCESS, data });


// reset password
export const RESET = action('RESET');
export const RESET_SUCCESS = action('RESET_SUCCESS');
export const RESET_ERROR = action('RESET_ERROR');

export const userReset = data => ({ type: RESET, data });
export const resetSuccess = data => ({ type: RESET_SUCCESS, data });
export const resetError = data => ({ type: userLoginError, data });

//signup
export const SIGNUP = action('SIGNUP');
export const SIGNUP_SUCCESS = action('SIGNUP_SUCCESS');
export const SIGNUP_ERROR = action('SIGNUP_ERROR');

export const signup = data => ({ type: SIGNUP, data });
export const signupSuccess = data => ({ type: SIGNUP_SUCCESS, data });
export const signupError = data => ({ type: SIGNUP_ERROR, data });

// forget password
export const FORGETPD = action('FORGETPD');
export const FORGETPD_SUCCESS = action('FORGETPD_SUCCESS');
export const FORGETPD_ERROR = action('FORGETPD_ERROR');

export const forgetPD = data => ({ type: FORGETPD, data });
export const forgetPDSuccess = data => ({ type: FORGETPD_SUCCESS, data });
export const forgetPDError = data => ({ type: FORGETPD_ERROR, data });

//get profile
export const GET_PROFILE = action('GET_PROFILE');
export const GET_PROFILE_SUCCESS = action('GET_PROFILE_SUCCESS');
export const GET_PROFILE_ERROR = action('GET_PROFILE_ERROR');

export const getProfile = data => ({ type: GET_PROFILE, data });
export const getProfileSuccess = data => ({ type: GET_PROFILE_SUCCESS, data });
export const getProfileError = data => ({ type: GET_PROFILE_ERROR, data });

const initialState = fromJS({

});

const auth = (state = initialState, action) => {
  switch (action.type) {
    //get profile
    case GET_PROFILE_SUCCESS:
      return state.set('profile', action.data);
    case GET_PROFILE_ERROR:
      return state = action.data;

    case LOGIN_SUCCESS:
      return state = action.data;
    case LOGIN_ERROR:
      return state = action.data;
    case RESET_SUCCESS:
      return state = action.data;
    case RESET_ERROR:
      return state = action.data;
    case SIGNUP_SUCCESS:
      return state = action.data;
    case SIGNUP_ERROR:
      return state = action.data;
    case FORGETPD_SUCCESS:
      return state = action.data;
    case FORGETPD_ERROR:
      return state = action.data;
    default:
      return state;
  }
};

export default auth;


// WEBPACK FOOTER //
// ./src/ducks/auth.js